<template>
  <div>
    <div class="bigTitle">专业解决方案</div>
    <div class="box">
      <div class="value physicians">
        <div class="img">
          <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/respondent/respondentbg.png" alt="">

        </div>
        <div class="title">受访者招募</div>
        <div class="text">
          <div class="one">
            我们为成千上万的研究提供优质的招募服务，包括定性或定量研究方法。我们的成功招募是基于敬业的工作、网络建设和创新的通信技术应用。我们的团队在这个领域积累了超过15年的经验。在此期间，我们不断扩大和更新我们的小组，这使我们能够通过将高质量的受访者带到他们的研究中。
          </div>
        </div>
        <div class="more" @click="toPath('/cn/respondent?source=webtable')">
          了解更多 ＞
        </div>
      </div>
      <div class="value patient">
        <div class="img">
          <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/research/researchbg.png" alt="">

        </div>
        <div class="title">定制研究社区</div>
        <div class="text">
          <div class="one">
            我们为客户设计、招募和管理定制的研究社区。通过社区研究，我们将一群热心的用户(或潜在用户)聚集在一起，为产品开发和产品体验改进提供及时、高质量的建议。
          </div>
        </div>
        <div class="more" @click="toPath('/cn/researchcommunity?source=webtable')">
          了解更多 ＞
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bigTitle {
  font-size: 40px;
  padding: 20px 120px 0;
  font-weight: 700;
}
.box {
  display: flex;
  justify-content: space-between;
  margin: 35px 120px 130px;
  .value {
    width: 49%;
    position: relative;

    // border: 1px solid #000;
    background-color: #2cb1e9;
    padding: 20px 20px 50px;
    color: #fff;
    .title {
      font-size: 20px;
      font-weight: 700;
    }
    .img {
      width: 150px;
      overflow: hidden;
      img {
        width: 300px;
        transform: translateX(-50%); /* 向左平移50%以显示右半边 */
      }
    }
    .text {
      .one,
      .two {
        margin-top: 10px;
      }
    }
    .more {
      position: absolute;
      bottom: 15px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .bigTitle {
    font-size: 80px;
  }
  .box {
    flex-wrap: wrap;
    .value {
      width: 100%;
      padding: 30px;
      margin-bottom: 20px;
      padding-bottom: 150px;
      .title {
        font-size: 75px;
      }
      .img {
        width: 500px;
        img {
          width: 1000px;
        }
      }
      .text {
        font-size: 70px;
      }
      .more {
        font-size: 70px;
      }
    }
  }
}
</style>